import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import classnames from 'classnames';

import Icon from '../general/Icon';

export default class Select extends React.PureComponent {
    static propTypes = {
        id: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]),
        type: PropTypes.string,
        className: PropTypes.string,
        label: PropTypes.any,
        labelClassName: PropTypes.string,
        groupClassName: PropTypes.string,
        outerClassName: PropTypes.string,
        children: PropTypes.any
    };

    static defaultProps = {
        id: null,
        type: null,
        className: null,
        label: null,
        labelClassName: null,
        groupClassName: null,
        outerClassName: null,
        children: null
    }

    get value () {
        return ReactDOM.findDOMNode(this.inputElement).value;
    }

    render () {
        const { id, className, label, labelClassName, groupClassName, outerClassName, children, ...props } = this.props;
        const classNames = classnames('input-field', className);

        return (
            <div className={outerClassName}>
                <FormGroup controlId={ id }
                    className={ groupClassName } >
                    { label && <ControlLabel className={ labelClassName }>{ label }</ControlLabel> }

                    <FormControl { ...props }
                        ref={ el => { this.inputElement = el; } }
                        componentClass="select"
                        className={ classNames } >
                            { children && children }
                    </FormControl>
                </FormGroup>

                <Icon icon="dropdown" />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/form/Select.js